<script setup lang="ts">
  import { computed } from 'vue';
  import { ColoredButton } from '@/shared/ui';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import FieldRef from './FieldRef.vue';

  const lab = useMatrixFillLabContext();

  const issues = computed(() => lab.compiled.value?.issues ?? []);
  const missing = computed(() => (lab.archiveAttempted.value ? lab.archive.value?.missing ?? [] : []));
  const ready = computed(() => lab.archiveAttempted.value && lab.archive.value?.ready === true);
  const hasAnchors = computed(() => lab.anchorFields.value.length > 0);
</script>

<template>
  <div
    class="flex flex-col gap-2"
    data-testid="fill-actions"
  >
    <div class="flex flex-wrap items-center gap-2">
      <ColoredButton
        text="Salvar"
        :disabled="issues.length > 0"
        data-testid="fill-save"
        @click="lab.saveResponse"
      />
      <ColoredButton
        text="Tentar arquivar"
        outlined
        :disabled="!hasAnchors"
        data-testid="archive-try"
        @click="lab.tryArchive"
      />
      <button
        type="button"
        class="ml-auto text-[var(--color-gray-05)] underline"
        data-testid="fill-clear"
        @click="lab.clearAnswers"
      >
        Limpar
      </button>
    </div>

    <div v-if="issues.length > 0">
      <p class="mb-1 font-semibold text-red-700">
        Corrija {{ issues.length }} campo(s) antes de salvar
      </p>
      <ul class="flex flex-col gap-1">
        <li
          v-for="issue in issues"
          :key="`${issue.fieldId}-${issue.code}`"
          class="flex items-center gap-2 rounded-md bg-red-50 px-2 py-1 text-red-800"
        >
          <FieldRef :id="issue.fieldId" />
          <span class="ml-auto shrink-0">{{ issue.message }}</span>
        </li>
      </ul>
    </div>
    <p
      v-else
      class="text-green-700"
    >
      Tudo certo para salvar.
    </p>

    <p
      v-if="ready"
      class="font-semibold text-green-700"
      data-testid="archive-ready"
    >
      Pronto para arquivar
    </p>
    <div
      v-else-if="missing.length > 0"
      data-testid="archive-blocked"
    >
      <p class="mb-1 font-semibold text-red-700">
        Não pode arquivar: {{ missing.length }} campo(s) âncora vazio(s)
      </p>
      <ul class="flex flex-col gap-1">
        <li
          v-for="id in missing"
          :key="id"
          class="rounded-md bg-red-50 px-2 py-1 text-red-800"
        >
          <FieldRef :id="id" />
        </li>
      </ul>
    </div>
    <p
      v-else-if="!hasAnchors"
      class="text-[10px] text-[var(--color-gray-05)]"
    >
      Esta matriz não tem campos âncora, então arquivar não exige nada além de salvar.
    </p>
  </div>
</template>
